import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import './i18n';
import ProtectedRoute from './components/ProtectedRoute';
import ThemePicker from './components/ThemePicker';
import ThemeCarouselIndicator from './components/ThemeCarouselIndicator';
import { ThemeCarouselProvider, useThemeCarousel } from './contexts/ThemeCarouselContext';
import DiagnosticsPage from './pages/DiagnosticsPage';
import EditorPage from './pages/EditorPage';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import StoriesDashboardPage from './pages/StoriesDashboardPage';
import StoryPage from './pages/StoryPage';
import ThemePreviewPage from './pages/ThemePreviewPage';

function CarouselAwareThemePicker() {
  const { currentThemeId, pauseFor } = useThemeCarousel();
  const DAY_MS = 24 * 60 * 60 * 1000;
  return (
    <ThemePicker
      liveThemeId={currentThemeId}
      onSelect={() => pauseFor(DAY_MS)}
    />
  );
}

function AppRoutes() {
  return (
    <>
      <ThemeCarouselIndicator />
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/health" element={<DiagnosticsPage />} />
        <Route path="/status" element={<DiagnosticsPage />} />

        {/* Public publication homepage — no auth required */}
        <Route path="/" element={<LandingPage />} />

        {/* Public story pages — each rendered via a Reporter theme */}
        <Route path="/story/:id" element={<StoryPage />} />

        {/* Protected routes — require valid JWT */}
        <Route path="/stories" element={<ProtectedRoute><StoriesDashboardPage /></ProtectedRoute>} />
        <Route path="/themes" element={<ProtectedRoute><CarouselAwareThemePicker /></ProtectedRoute>} />
        <Route path="/preview" element={<ProtectedRoute><ThemePreviewPage /></ProtectedRoute>} />
        <Route path="/editor" element={<ProtectedRoute><EditorPage /></ProtectedRoute>} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ThemeCarouselProvider>
        <AppRoutes />
      </ThemeCarouselProvider>
    </BrowserRouter>
  );
}

export default App;
